/* sh-branchement.js : nos ajouts branchés sur le thème (module AJOUTS, 02/10/2026).
   Repris de outputs/shestia-sky-2026-09-26/build/fusion/branchement.js : sa logique, ses accroches réécrites vers nos
   éléments (CONVENTIONS §2 : « ses accroches aux classes de Sky sont à réécrire vers nos éléments »).
   Le quiz (sh-quiz.js) et le Build your closet (sh-closet.js) ajoutent une robe par window.ShestiaCart.add(sélection) et
   window.ShestiaCart.addMany(sélections) ; ici :
   1. ShestiaCart ajoute par le panier du thème : Shestia.cart.add (routes Ajax de Shopify, sh-core.js de SOCLE) avec
      l'identifiant de variante de la couleur et de la taille choisies, puis Shestia.drawers.open('cart') ;
   2. le verrou : le quiz et le closet signalent leur ouverture par body.lock ; le verrou du thème (Shestia.lock, Lenis
      arrêté compris) suit, et se relâche à leur fermeture ;
   3. la molette : data-lenis-prevent sur la popup et le closet, pour que Lenis leur laisse la molette (relevé sur la
      référence : sans lui, la page descendait derrière le closet ouvert) ;
   4. un lien qui ouvre le closet depuis le tiroir du menu ferme d'abord le tiroir (il restait ouvert derrière).
   Chargé après les données (snippets/sh-shestia-data.liquid), avant sh-shestia-ui.js, sh-quiz.js et sh-closet.js. */
(function () {
  'use strict';
  var S = window.Shestia;
  if (!S || !S.products) return;

  /* 1. Le panier du thème */
  function lignes(selections) {
    var out = [];
    for (var i = 0; i < selections.length; i++) {
      var s = selections[i], v = s && s.size && S.variante ? S.variante(s.id, s.colour, s.size) : null;
      if (!v) return null;          /* une sélection sans variante réelle : rien n'est ajouté */
      out.push({id: v.id, quantity: Math.max(1, Math.min(99, Math.floor(Number(s.qty)) || 1))});
    }
    return out.length ? out : null;
  }
  function signaler(message) {
    if (window.ShestiaUI && window.ShestiaUI.toast) window.ShestiaUI.toast(message || 'This dress could not be added.');
  }
  function ajouter(selections) {
    var items = lignes(selections);
    if (!items) return false;
    if (!S.cart || typeof S.cart.add !== 'function') {
      window.location = (S.config && S.config.routes && S.config.routes.cart) || '/cart';
      return true;
    }
    S.cart.add(items).then(function () {
      if (S.drawers) S.drawers.open('cart');
    }).catch(function (e) {
      console.error('[shestia-ajouts] ajout refusé', e);
      signaler(e && e.message);
    });
    return true;
  }
  window.ShestiaCart = {
    add: function (selection) { return ajouter([selection]); },
    addMany: function (selections) { return ajouter(selections || []); },
    open: function () { if (S.drawers) S.drawers.open('cart'); else window.location = '/cart'; },
    variante: S.variante
  };

  /* 2. Le verrou du thème suit body.lock */
  var verrou = false;
  function suivreVerrou() {
    var on = document.body.classList.contains('lock');
    if (on === verrou) return;
    verrou = on;
    if (on) { if (typeof S.lock === 'function') S.lock(); }
    else if (typeof S.unlock === 'function') S.unlock();
  }
  new MutationObserver(suivreVerrou).observe(document.body, {attributes: true, attributeFilter: ['class']});

  /* 3. La molette laissée à la popup et au closet (sh-quiz.js crée .fm à son chargement, sh-closet.js remplit [data-byc] :
     tous deux ont tourné avant cet événement) */
  function prevenir() { document.querySelectorAll('.fm, [data-byc]').forEach(function (e) { e.setAttribute('data-lenis-prevent', ''); }); }
  /* Ce script différé tourne avant sh-quiz.js : DOMContentLoaded arrive après tous les scripts différés ; load en filet. */
  if (document.readyState === 'complete') prevenir();
  else { document.addEventListener('DOMContentLoaded', prevenir); window.addEventListener('load', prevenir); }

  /* 4. Le lien « Build your closet » du tiroir du menu : le tiroir se ferme avant que le closet s'ouvre (capture). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-byc-open], a[href$="#build-your-closet"]');
    var tiroir = a && a.closest('sh-drawer[open]');
    if (tiroir && S.drawers) S.drawers.close(tiroir.getAttribute('name'), {remplace: true});
  }, true);
})();
